import styled from 'styled-components';

export const MarginRightAuto = styled.div`
	margin-right: auto;
`;

export const MarginBottom = styled.div`
	margin-bottom: 32px;
`;

export const Container = styled.div`
	margin-bottom: 32px;
`;

export const ButtonsContainer = styled.div``;

export const ButtonContainer = styled.div``;

export const HeaderNameContainer = styled.div`
	width: 55vw;
`;
